export enum FinOpsPermissions {
  ViewDashboard = 'FIN_OPS.DASHBOARD.VIEW',
  ViewChartOfAccounts = 'FIN_OPS.CHART_OF_ACCOUNTS.VIEW',
  ViewTrialBalance = 'FIN_OPS.TRIAl_BALANCE.ACCOUNTS.VIEW',
  ViewMonthEndReadiness = 'FIN_OPS.MONTH_END_READINESS.VIEW',
  ViewDoaRequests = 'FIN_OPS.DOA.VIEW',
  ViewBankReconciliation = 'FIN_OPS.BANK_RECON.VIEW',
  ReconcileTransactions = 'FIN_OPS.BANK_RECON.MATCH.CREATE',
  ViewReporting = 'FIN_OPS.REPORTING.VIEW',
  ViewJournals = 'FIN_OPS.JOURNALS.VIEW',
  CreatePostings = 'FIN_OPS.JOURNALS.CREATE',
  AuthorisePostings = 'FIN_OPS.JOURNALS.AUTH',

  ViewReleasePayments = 'FIN_OPS.RELEASE_PAYMENTS.VIEW',
  RequestReleasePayments = 'FIN_OPS.RELEASE_PAYMENTS.REQUEST',
  FirstApprovalReleasePayments = 'FIN_OPS.RELEASE_PAYMENTS.FIRST_APPROVAL',
  FinalApprovalReleasePayments = 'FIN_OPS.RELEASE_PAYMENTS.FINAL_APPROVAL',
  ActionPaymentItem = 'FIN_OPS.RELEASE_PAYMENTS.ACTION_PAYMENT_ITEM',

  PaymentRejections = 'FIN_OPS.PAYMENT_REJECTIONS.VIEW',
  PensionPaymentRejections = 'FIN_OPS.PAYMENT_REJECTIONS.PENSIONS.VIEW',
  EapPaymentRejections = 'FIN_OPS.PAYMENT_REJECTIONS.EAP.VIEW',
  UnderwritingPaymentRejections = 'FIN_OPS.PAYMENT_REJECTIONS.UNDERWRITING.VIEW',
  ClaimPaymentRejections = 'FIN_OPS.PAYMENT_REJECTIONS.CLAIMS.VIEW',

  PaymentRejectionsAdmins = 'FIN_OPS.PAYMENT_REJECTIONS.ADMINISTRATOR.VIEW',
  PensionPaymentRejectionsAdmins = 'FIN_OPS.PAYMENT_REJECTIONS.PENSIONS.ADMINISTRATOR.VIEW',
  EapPaymentRejectionsAdmins = 'FIN_OPS.PAYMENT_REJECTIONS.EAP.ADMINISTRATOR.VIEW',
  UnderwritingPaymentRejectionsAdmins = 'FIN_OPS.PAYMENT_REJECTIONS.UNDERWRITING.ADMINISTRATOR.VIEW',
  ClaimPaymentRejectionsAdmins = 'FIN_OPS.PAYMENT_REJECTIONS.CLAIMS.ADMINISTRATOR.VIEW',
}
